module.exports = __webpack_public_path__ + "img/gj_1.214ce0a4.jpg";